import { render, staticRenderFns } from "./GoToSetup.vue?vue&type=template&id=6a66aa29&scoped=true&"
import script from "./GoToSetup.vue?vue&type=script&lang=js&"
export * from "./GoToSetup.vue?vue&type=script&lang=js&"
import style0 from "./GoToSetup.vue?vue&type=style&index=0&id=6a66aa29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a66aa29",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
